<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ {{ order_header.order_code }}</b></div>
            <div v-if="order_header.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>
            <div v-if="order_header.status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #fdac39">ดำเนินการจัดสินค้า</b></div>
            <div v-if="order_header.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #86bc3a">สำเร็จ</b></div>
            <div v-if="order_header.status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: red">ยกเลิกคำสั่งซื้อ</b></div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลพาร์ทเนอร์</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อพาร์ทเนอร์ : </div>
              <div class="ml-1 mr-3">{{ order_header.name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="order_header.telephone !== null" class="ml-1 mr-3">{{ order_header.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การตอบกลับจากฟาร์มาแคร์พลัส</b></div>
                <div v-if="order_header.status === 0" class="mt-3">
                  <div class="ml-1 mr-3">ยังไม่มีการตอบกลับ</div>
                </div>
                <div v-else-if="order_header.status === 1" class="d-flex mt-2" style="color: #86bc3a;">
                  <div class="ml-1 mr-3">อนุมัติคำสั่งซื้อ : </div>
                  <div class="ml-1 mr-3">{{ order_header.partner_confirm_name }} {{ format_date(order_header.confirm_date)
                  }}</div>
                </div>
                <div v-else-if="order_header.status === 2">
                  <div class="d-flex mt-2" style="color: #86bc3a;">
                    <div class="ml-1 mr-3">อนุมัติคำสั่งซื้อ : </div>
                    <div class="ml-1 mr-3">{{ order_header.partner_confirm_name }} {{ order_header.confirm_date ?
                      format_date(order_header.confirm_date) : '' }}</div>
                  </div>
                  <div class="d-flex mt-2" style="color: #86bc3a;">
                    <div class="ml-1 mr-3">ส่งแล้ว : </div>
                    <div class="ml-1 mr-3">{{ order_header.partner_confirm_name }} {{
                      format_date(order_header.partner_confirm_date) }}</div>
                  </div>
                </div>
                <div v-else-if="order_header.status === 3">
                  <div class="d-flex mt-2" style="color: red;">
                    <div class="ml-1 mr-3">ยกเลิกคำสั่งซื้อ : </div>
                    <div class="ml-1 mr-3">{{ order_header.partner_confirm_name }} {{
                      format_date(order_header.confirm_date) }}</div>
                  </div>
                  <div class="d-flex mt-2" style="color: red;">
                    <div class="ml-1 mr-3">เหตุผล : </div>
                    <div class="ml-1 mr-3">{{ order_header.cancel_note }}</div>
                  </div>
                </div>
              </div>
              <!--              <div class="mt-2 display_mobile">-->
              <!--                <v-btn elevation="5" @click="image_modal = true" class="mobile_btn pa-6 grad-warning-bg white&#45;&#45;text rounded-pill">ยืนยันการตรวจสอบ</v-btn>-->
              <!--              </div>-->
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider />
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage"
                hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr v-if="dataDetail.item.product_cancel !== 1">
                    <td class="border_table pa-3">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" height="120" width="120" max-width="120"
                          v-if="dataDetail.item.product_picture !== null" :lazy-src="picture_product"
                          :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="mx-auto rounded" height="120" width="120" max-width="120" v-else
                          :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div>{{ dataDetail.item.product_name }}<br>
                        <!-- <b class="primary--text" v-if="dataDetail.item.count_in_warehouse">จำนวนคงเหลือในคลัง :
                          {{ dataDetail.item.count_in_warehouse }}</b> -->
                        <b :class="{ 'primary--text': parseInt(dataDetail.item.count_warehouse) >= dataDetail.item.count_min_unit, 'error--text': dataDetail.item.count_warehouse < dataDetail.item.count_min_unit }"
                          v-if="dataDetail.item.count_in_warehouse">จำนวนคงเหลือในคลัง :
                          {{ dataDetail.item.count_in_warehouse }}</b>
                      </div>
                      <div v-if="dataDetail.item.product_list !== null">
                        <div v-for="(  data, index  ) in   dataDetail.item.product_list  " :key="index">
                          <small class="pl-3">- {{ data.name }} ({{ data.quantity }} {{ data.unit_name }})</small>
                          <br>
                          <small class="pl-5 primary--text" v-if="data.count_in_warehouse"><b>จำนวนคงเหลือในคลัง : {{
                            data.count_in_warehouse }}</b></small>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.cost) }}</td>
                    <td class="border_table text-center">{{ format_number(dataDetail.item.qty) }} {{
                      dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                  <tr v-else>
                    <td class="border_table pa-3">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" height="120" width="120" max-width="120"
                          v-if="dataDetail.item.product_picture !== null" :lazy-src="picture_product"
                          :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="mx-auto rounded" height="120" width="120" max-width="120" v-else
                          :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div><s class="red--text">{{ dataDetail.item.product_name }}</s></div>
                      <div v-if="dataDetail.item.product_list !== null">
                        <div v-for="(  data, index  ) in   dataDetail.item.product_list  " :key="index">
                          <small class="pl-3"><s class="red--text">- {{ data.name }} ({{ data.quantity }} {{
                            data.unit_name }})</s></small>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center"><s class="red--text">{{ format_price(dataDetail.item.cost) }}</s>
                    </td>
                    <td class="border_table text-center"><s class="red--text">{{ format_number(dataDetail.item.qty) }} {{
                      dataDetail.item.unit_name }}</s></td>
                    <td class="border_table text-center"><s class="red--text">{{ format_price(dataDetail.item.total)
                    }}</s></td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td v-if="order_header.delivery_price !== null" class="border_table text-center"><b>{{
                      format_number(order_header.delivery_price) }}</b></td>
                    <td v-else class="border_table text-center"><b>0.00</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td v-if="order_header.delivery_type !== 1" class="border_table text-center"><b>{{ result_total =
                    format_price(total + parseFloat(result_weight)) }}</b></td>
                    <td v-else class="border_table text-center"><b>{{ result_total = format_price(total) }}</b></td>
                  </tr>
                </template>
              </v-data-table>
              <div class="mt-4" v-if="order_header.status === 0">
                <v-btn large elevation="5" style="font-size: 18px" @click="print_invoice(order_header.order_code)"
                  class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
                  <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
                </v-btn>
              </div>
            </div>
          </v-card>
          <div v-if="order_header.status === 0" class="text-center pa-5 mb-3">
            <v-btn large elevation="5" style="font-size: 18px" @click="get_edit"
              class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขคำสั่งซื้อ
            </v-btn>
            <v-btn large elevation="5" style="font-size: 18px" @click="approve_confirm"
              class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
              <v-icon>mdi-check-bold</v-icon> อนุมัติคำสั่งซื้อ
            </v-btn>
            <v-btn large elevation="5" style="font-size: 18px" @click="cancel_order = true"
              class="mobile_grid ml-1 mr-1 pa-6 grad-danger-bg white--text rounded-pill">
              <v-icon>mdi-close-thick</v-icon> ยกเลิกคำสั่งซื้อ
            </v-btn>
          </div>
          <div v-else-if="order_header.status === 1" class="text-center pa-5 mb-3">
            <v-btn large elevation="5" style="font-size: 18px" @click="get_confirm_edit"
              class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
            </v-btn>
            <v-btn large elevation="5" style="font-size: 18px" @click="print_invoice(order_header.order_code)"
              class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>
          </div>
          <div v-else-if="order_header.status === 2" class="text-center pa-5 mb-3">
            <v-btn large elevation="5" style="font-size: 18px" @click="print_invoice(order_header.order_code)"
              class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>
          </div>

          <div class="text-center pa-5 mb-3" v-else-if="order_header.status === 4">
            <v-btn large elevation="5" @click="order_edit" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
            </v-btn>
            <v-btn large elevation="5" @click="print_send_order" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>
            <!-- <v-btn v-if="order_header.tax_invoice === 0" large elevation="5" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-grey-bg white--text rounded-pill" disabled>
              <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
            </v-btn>
            <v-btn v-else-if="order_header.tax_invoice === 1" large elevation="5" @click="print_tax_invoice" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
            </v-btn> -->
          </div>

        </div>
        <v-dialog v-model="cancel_order" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยกเลิกคำสั่งซื้อ
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  <div class="ma-3 ml-1">คุณต้องการยกเลิกคำสั่งซื้อของลูกค้าเพราะเหตุใด ?</div>
                  <v-text-field color="#86bc3a" clearable class="rounded-pill" type="text"
                    label="กรุณากรอกเหตุผลการยกเลิกออเดอร์" :rules="[v => !!v || 'กรุณากรอกเหตุผลการยกเลิกออเดอร์']"
                    prepend-inner-icon="mdi-truck-minus-outline" v-model="cancel_note" hide-details="auto"
                    outlined></v-text-field>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-danger-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ยกเลิกคำสั่งซื้อ
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_product from "@/assets/pill.png";
import { formatNumber, formatPrice } from "@/js/handler";
import { HTTP } from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_partner_detail",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_product: picture_product,
      cancel_order: false,
      perPage: -1,
      overlay: false,
      image_modal: false,
      order_number: '',
      cancel_note: '',
      weight_all: 0,
      result_weight: 0,
      result_total: 0,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      order_header: [],
      slip_img: [],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    format_date(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      return day + '/' + month + '/' + year
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('wholesales/orderdetail', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.order_header = res.data.order_head
          this.data_list = res.data.order_list
          // this.slip_img = res.data.object.slip_picture[0]
          res.data.order_list.forEach((data) => {
            this.weight_all += data.qty * parseFloat(data.weight)
          })
          this.get_price_rate(this.weight_all)
        }
      })
    },
    async get_price_rate(weight) {
      let get_weight = this.format_price(weight)
      let math_weight = Math.ceil(get_weight)
      let weight_arr = []
      await HTTP.get('wholesales/price_rate')
        .then((res) => {
          if (res.data.success === true) {
            res.data.price_rate.forEach((data) => {
              weight_arr.push({
                id: data.id,
                rate_end: data.rate_end !== null ? data.rate_end : '0.00',
                rate_price: data.rate_price,
                rate_start: data.rate_start !== null ? data.rate_start : '0.00',
                rate_type: data.rate_type,
              })
            })
            let result_weight = weight_arr.find((data) => (math_weight >= parseFloat(data.rate_start)))
            this.result_weight = result_weight.rate_price
          }
        })
    },
    approve_confirm() {
      Swal.fire({
        title: 'ต้องการอนุมัติคำสั่งซื้อหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.overlay = true
          HTTP.post('/wholesales/approvepartner', {
            order_id: this.order_header.id,
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              this.get_data()
            }
          })
        }
      })
    },
    get_edit() {
      this.$router.push('/sell/orderpartneredit/' + this.$route.params.id)
    },
    get_confirm_edit() {
      this.$router.push('/sell/orderpartnereditlots/' + this.order_header.id)
    },
    wait_for_save() {
      if (this.$refs.update.validate()) {
        this.overlay = true
        HTTP.post('/wholesales/cancelpartner', {
          order_id: this.order_header.id,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
          cancel_note: this.cancel_note
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            this.cancel_order = false
            this.get_data()
          }
        })
      }
    },
    close_modal() {
      this.cancel_order = false
      this.cancel_note = ''
    },
    print_invoice(order_code) {
      window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + order_code, '_blank')
      window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + order_code, '_blank')
    },
    order_edit() {
      const id = this.$route.params.id
      this.$router.push('/sell/orderpartnereditlots/' + id)
    },
    print_send_order() {
      if (this.order_header.delivery_type !== 1) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/envelopewholesale/' + this.order_header.order_code, '_blank')
      }
      else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + this.order_header.order_code, '_blank')
      }
    },
    print_tax_invoice() {
      window.open('https://www.pharmacare-plus.com/taxinvoicewholesale/' + this.order_header.order_code, '_blank')
    }
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = number.cost * number.qty
        if (total_price < 0) {
          return sum + (0)
        }
        else {
          return sum + (total_price);
        }
      }, 0)
      return result;
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}

.rounded_card {
  border-radius: 15px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

.grid_img {
  display: grid;
  grid-template-columns: 70% 30%;
}

.border_table {
  border: #e0e0e0 solid 1px
}

.mobile_btn {
  width: 50%;
}

.display_pc {
  display: block;
}

.display_mobile {
  display: none;
}

.mobile_grid {
  width: 25%
}

@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_grid {
    width: 32%
  }
}

@media only screen and (max-width: 500px) {
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }

  .grid_mx {
    margin: auto;
  }

  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_btn {
    width: 100%;
  }

  .display_pc {
    display: none;
  }

  .display_mobile {
    display: block;
  }
}
</style>
